// Strona kalkulatora gięcia tworzyw sztucznych - używa ORYGINALNEGO komponentu z produkcyjną wiedzą
import React from 'react';
import { ArrowLeft, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import BendingCalculator from '../components/technical/bending';

const BendingCalculatorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-900 text-white">
      {/* Nawigacja - spójny styl */}
      <div className="bg-zinc-800 border-b border-zinc-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-zinc-400 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Powrót</span>
            </button>
            
            <div className="text-sm text-zinc-500">
              PlexiSystem - Moduły Techniczne
            </div>
          </div>
        </div>
      </div>

      {/* ORYGINALNY KOMPONENT Z PRODUKCYJNĄ WIEDZĄ */}
      <BendingCalculator />
      
      {/* Stopka - spójny styl */}
      <div className="bg-zinc-800 border-t border-zinc-700 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="text-center text-sm text-zinc-500">
            © 2025 PlexiSystem - Kalkulator Parametrów Gięcia v2.0
          </div>
        </div>
      </div>
    </div>
  );
};

export default BendingCalculatorPage;